import React, { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';

import I18n from 'lib/utils/i18n';
import { isServer } from 'lib/common/constants';

const I18N = '__NEXT_I18N__';

function getOrCreateI18n(translations, phraseappEnabled, language, bcp47) {
  // Always create a new i18n instance if server
  if (isServer) {
    return new I18n(translations, phraseappEnabled, language, bcp47);
  }

  // Create i18n instance if unavailable on the client and set it on the window
  // object
  if (!window[I18N]) {
    window[I18N] = new I18n(translations, phraseappEnabled, language, bcp47);
  }
  return window[I18N];
}

/**
 * withI8n initializes the i18n helper on the server and on the client. It
 * attaches it to the context to it's available outside of React components
 * (i.e. in action creators).
 */
const withI18n = (App) =>
  class WithI18n extends Component {
    static propTypes = {
      /* eslint-disable-next-line react/forbid-prop-types */
      translations: PropTypes.object.isRequired,
      phraseappEnabled: PropTypes.bool.isRequired,
      language: PropTypes.string.isRequired,
      bcp47: PropTypes.string.isRequired,
    };

    static async getInitialProps(context) {
      const { ctx } = context;
      const { translations, phraseappEnabled, language, bcp47 } = ctx.req || {};

      ctx.i18n = getOrCreateI18n(
        translations,
        phraseappEnabled,
        language,
        bcp47,
      );

      const appProps =
        App.getInitialProps && (await App.getInitialProps(context));

      return { ...appProps, translations, phraseappEnabled, language, bcp47 };
    }

    constructor(props) {
      super(props);
      const { translations, phraseappEnabled, language, bcp47 } = props;
      this.i18n = getOrCreateI18n(
        translations,
        phraseappEnabled,
        language,
        bcp47,
      );
    }

    render() {
      const appProps = omit(
        this.props,
        'translations',
        'phraseappEnabled',
        'language',
        'bcp47',
      );
      return <App {...appProps} i18n={this.i18n} />;
    }
  };

export default withI18n;
